import { useInstitution } from "@/features/institutions/hooks/useInstitution";
import { InstitutionMembersTab } from "@/features/institutions/components/InstitutionMembersTab";
import { InlineLoader } from "@/components/ui/pulsing-loader";

const DN_SLUG = "directorio-nacional";

export default function NacionalMembersTab() {
  const { data: institution, isLoading } = useInstitution(DN_SLUG);

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <InlineLoader message="Cargando..." />
      </div>
    );
  }

  if (!institution) return null;

  return (
    <div className="container mx-auto py-6">
      <InstitutionMembersTab institutionId={institution.id} />
    </div>
  );
}
